// Copyright (c) 2016 Deere & Company

import Statuses, {getDefaultState} from '../state/statuses';
import actions from '../../actions-list';

const updateDemoRentalStatus = (state, action) =>
    Statuses.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DEMO_RENTAL_STATUS_SUCCESS]: updateDemoRentalStatus
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/reducers/statuses.js